import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { buyerType, conditionType } from 'src/app/shared/const/options';
import { observations, } from 'src/app/shared/const/prices.const';
import { DateChecker } from '@shared-logic/utils';
import { buyers } from 'src/app/shared/dict/buyers';
import { PRODUCT_NAMES } from '@shared-logic/products';
import { typeBusiness } from '@shared-logic/business-type';
import { wayPay } from '@shared-logic/payments';
import { Price, priceState, typeCoin } from '@shared-logic/prices';
import { ViewPrice } from 'src/app/shared/interfaces/views.interface';
import { RowHead } from '../../row-head';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { setShowDeletePrice } from 'src/app/redux/actions/options.action';
import { quality } from '@shared-logic/qualities';
import { puertos } from '@shared-logic/locations';
import { areas } from '@shared-logic/user';
import { Subscription } from 'rxjs';
import { BUSINESS_PARTICULARITIES_FILTER_OPTIONS } from 'src/app/shared/utils/business-particularities-filter.util';

@Component({
  selector: 'tr[row-price-head]',
  templateUrl: './row-price-head.component.html',
  styleUrls: ['./row-price-head.component.scss']
})
export class RowPriceHeadComponent extends RowHead implements OnInit, OnDestroy {
  @Input() viewSelected!: ViewPrice;
  @Input() buyerType: string = '';
  @Input() conditionType: string = '';
  @Input() pricesSelected: Price[] = [];

  buyerTypes = buyerType;
  CONDITION_TYPES = conditionType;

  STATUS: any = [];
  BUSINESS_TYPE: any = [];
  PLACE_OF_DELIVERY: any = [];
  QUALITY: any = [];
  TYPE_COIN: any = [];
  WAY_PAY: any = [];
  PRODUCTS: any = [];
  OBSERVATIONS: any = [];
  HARVEST: any = [];
  BUYERS: any = [];
  BUSINESS_PARTICULARITIES: string[] = BUSINESS_PARTICULARITIES_FILTER_OPTIONS;

  isOperator: boolean = false;
  private userSub!: Subscription;

  constructor(private dateC: DateChecker, private store: Store<appState>) {
    super();
  }

  ngOnInit(): void {
    this.setArrays();
    this.userSub = this.store.select('usuario').subscribe(user => {
      this.isOperator = user.area === areas.commodities;
    });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  deletePrices() {
    this.store.dispatch(setShowDeletePrice({ isShow: true, idPrice: '' }));
  }

  setArrays() {
    this.STATUS = priceState;
    this.BUSINESS_TYPE = typeBusiness;
    this.QUALITY = quality;
    this.PLACE_OF_DELIVERY = puertos;
    this.TYPE_COIN = typeCoin;
    this.WAY_PAY = wayPay;
    this.PRODUCTS = PRODUCT_NAMES;
    this.OBSERVATIONS = [observations.featuredPrice, observations.gravanz, observations.comment];
    this.BUYERS = buyers;
    this.HARVEST = this.dateC.getHarvest();
  }
}